import React from "react";
import Login from "./../../components/Login/index";

function SignUp() {
  return <Login signup />;
}

export default SignUp;
